import de from '@translations/de/catalogueForm.json';
import en from '@translations/en/catalogueForm.json';
import pl from '@translations/pl/catalogueForm.json';
import sl from '@translations/sl/catalogueForm.json';
import uk from '@translations/uk/catalogueForm.json';
import bg from '@translations/bg/catalogueForm.json';
import cz from '@translations/cz/catalogueForm.json';
import fr from '@translations/fr/catalogueForm.json';
import gr from '@translations/gr/catalogueForm.json';
import it from '@translations/it/catalogueForm.json';
import pr from '@translations/pr/catalogueForm.json';
import ru from '@translations/ru/catalogueForm.json';
import sk from '@translations/sk/catalogueForm.json';
import sp from '@translations/sp/catalogueForm.json';
import tr from '@translations/tr/catalogueForm.json';
import hu from '@translations/hu/catalogueForm.json';
import { ITranslations } from '@/types/common';
import { CatalogueFormTransFields } from './types';

export const catalogueFormTranslations: ITranslations<CatalogueFormTransFields> = {
  name: 'catalogueForm',
  de,
  en,
  pl,
  sl,
  uk,
  bg,
  cz,
  fr,
  gr,
  it,
  pr,
  ru,
  sk,
  sp,
  tr,
  hu,
};
